import { render, staticRenderFns } from "./AddTest.vue?vue&type=template&id=91f8a7c6&"
import script from "./AddTest.vue?vue&type=script&lang=js&"
export * from "./AddTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports